import React, {
 useState
} from 'react';
import {
    Input
} from 'shared/components/ui/input';
import {
    Badge
} from 'shared/components/ui/badge';
import {
 X
} from 'lucide-react';

interface ChipInputProps {
  values: string[];
  onChange: (next: string[]) => void;
  placeholder?: string;
  className?: string;
}

// Comma- or Enter-separated text -> chips. Used for context_keys,
// propensity_keys, allowed_actions, denied_actions, retention hints.
export default function ChipInput({
    values, onChange, placeholder, className = '',
}: ChipInputProps) {
    const [buf, setBuf] = useState('');

    const commit = () => {
        const trimmed = buf.trim();
        if (!trimmed) return;
        if (values.includes(trimmed)) { setBuf(''); return; }
        onChange([...values, trimmed]);
        setBuf('');
    };

    const remove = (v: string) => onChange(values.filter(x => x !== v));

    return (
        <div className={`space-y-2 ${className}`}>
            <div className="flex flex-wrap gap-1">
                {values.map(v => (
                    <Badge key={v} variant="secondary" className="gap-1 text-xs">
                        {v}
                        <button
                            type="button"
                            onClick={() => remove(v)}
                            className="hover:text-destructive"
                            aria-label={`remove ${v}`}
                        >
                            <X className="h-3 w-3" />
                        </button>
                    </Badge>
                ))}
            </div>
            <Input
                value={buf}
                onChange={(e) => setBuf(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ',') {
                        e.preventDefault();
                        commit();
                    }
                }}
                onBlur={commit}
                placeholder={placeholder || 'Type and press Enter'}
                className="h-8 text-sm"
            />
        </div>
    );
}
